import React from 'react';
import { Path, SVG } from 'web-common/src/shared/design-system/Utilities';

/**
 * @deprecated Use AllergenDairy icon instead with `isCrossed` prop. <AllergenDairy isCrossed />
 */
export const DairyFree = (props: React.SVGProps<SVGSVGElement>) => (
  <SVG width='16' height='16' viewBox='0 0 16 16' fill='none' {...props}>
    <title>Dairy free dish</title>
    <desc>An old-fashioned milk bottle with a slash through it</desc>
    <Path
      d='M4.75 1.65385C4.75 1.32967 5.04736 1 5.5 1H10.5C10.9527 1 11.25 1.32967 11.25 1.65385C11.25 1.97803 10.9527 2.30769 10.5 2.30769H5.5C5.04736 2.30769 4.75 1.97802 4.75 1.65385ZM12.5 10.5802L5.87143 4.46154H10.2586L12.5 7.28286V10.5802ZM10.3942 15H3.5V8.63615L10.3942 15Z'
      fill='currentColor'
      stroke='#currentColor'
    />
    <Path
      d='M0.490029 2.5252C0.829084 2.17601 1.38503 2.15293 1.73178 2.47364L14.6582 14.4294C15.005 14.7501 15.0112 15.2932 14.6722 15.6424C14.3331 15.9916 13.7771 16.0147 13.4304 15.6939L0.503951 3.73815C0.157206 3.41744 0.150973 2.87438 0.490029 2.5252Z'
      fill='currentColor'
    />
  </SVG>
);
